import React, { useEffect, useState } from 'react';
import './ChiefInvestigators.css';
import Footer from '../Footer/Footer';
import { Header2 } from '../NavBar/Header2';
import {
  MDBCard,
  MDBCardImage,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBCardFooter,
  MDBCol
} from 'mdb-react-ui-kit';
import SchoolIcon from '@mui/icons-material/School';
import EmailIcon from '@mui/icons-material/Email';
import '../../App.css';

const flags = importAll(require.context('../../images/Flags', false, /\.(png)$/));

function importAll(r) {
  let flags = {};
  r.keys().map((item, index) => { flags[item.replace('./', '')] = r(item); });
  return flags;
}

const ci_images = importImages(require.context('../../images/CI_Images', false, /\.(png|jpe?g|svg)$/));

function importImages(r) {
  let ci_images = {};
  r.keys().map((item, index) => { ci_images[item.replace('./', '')] = r(item); });
  return ci_images;
}

let ci_data = [
  {
    ci_country: 'Albania',
    ci_flag: flags['alb.png'],
    ci_name: 'Juel Jarani',
    ci_university: '--',
    ci_email: '--',
    ci_image: ci_images['NoPhoto.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Algeria',
    ci_flag: flags['alg.png'],
    ci_name: 'Benaissa Redha',
    ci_university: 'Universities of Boumerdes Algeria',
    ci_email: 'monredha@hotmail.fr',
    ci_image: ci_images['Redha Algeria.jpeg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Australia',
    ci_flag: flags['au.png'],
    ci_name: 'Dist. Prof Tony Okely',
    ci_university: 'University Of Wollongong',
    ci_email: 'tokely@uow.edu.au',
    ci_image: ci_images['Tony-Okely_opt.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Bangladesh',
    ci_flag: flags['bd.png'],
    ci_name: 'Mohammad Sorowar Hossain',
    ci_university: 'Biomedical Research Foundation, Bangladesh',
    ci_email: 'sorowar.hossain@brfbd.org',
    ci_image: ci_images['Mohammad Sorowar Hossain Bangladesh.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Bosnia and Herzegovina',
    ci_flag: flags['boh.png'],
    ci_name: 'Edin Užičanin',
    ci_university: 'University of Tuzla, Faculty of Physical Education and sport',
    ci_email: 'edin.uzicanin@unitz.ba',
    ci_image: ci_images['Edin-Užičanin. Bosnia and Herzegovina.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Botswana',
    ci_flag: flags['bw.png'],
    ci_name: 'Dawn Mahube Tladi',
    ci_university: 'University of Botswana',
    ci_email: 'tladidm@ub.ac.bw',
    ci_image: ci_images['Dawn Botswana.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Brazil',
    ci_flag: flags['br.png'],
    ci_name: 'Alex Antonio Florindo',
    ci_university: 'University of Sao Paulo, Brazil',
    ci_email: 'aflorind@usp.br',
    ci_image: ci_images['Alex Antonio Florindo Brazil.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Cabo Verde',
    ci_flag: flags['cpe.png'],
    ci_name: 'Emanuel Passos',
    ci_university: 'National Anti-Doping Organization of Cabo Verde',
    ci_email: 'Emanuel.Passos@onad.gov.cv',
    ci_image: ci_images['CaboVerde-Emanuel.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Cameroon',
    ci_flag: flags['cm.png'],
    ci_name: 'Ijang Bih Ngyah-Etchutambe',
    ci_university: 'University of Buea, Cameroon',
    ci_email: 'ijangetchu@gmail.com',
    ci_image: ci_images['Ijang Bih.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Canada',
    ci_flag: flags['cn.png'],
    ci_name: 'Mark Tremblay',
    ci_university: 'CHEO Research Institute, Canada',
    ci_email: 'mtremblay@cheo.on.ca',
    ci_image: ci_images['Mark-Tremblay_opt.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Chile',
    ci_flag: flags['cl.png'],
    ci_name: 'Nicolas Aguilar-Farias',
    ci_university: 'Universidad de La Frontera, Chile',
    ci_email: 'nicolas.aguilar@ufrontera.cl',
    ci_image: ci_images['NoPhoto.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'China',
    ci_flag: flags['ca.png'],
    ci_name: 'Guan Hongyan',
    ci_university: 'Capital Institute of Pediatrics, China',
    ci_email: 'Hongyanguan@126.com',
    ci_image: ci_images['Hongyan Guan China.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Colombia',
    ci_flag: flags['clb.png'],
    ci_name: 'Jhonatan González Santamaría',
    ci_university: 'Fundación Universitaria del Área Andina',
    ci_email: 'jgonzalez@utp.edu.co',
    ci_image: ci_images['Jhonatan González Santamaría.png'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Costa Rica',
    ci_flag: flags['cr.png'],
    ci_name: 'Jorge Cervantes Sanabria',
    ci_university: 'Universidad de Costa Rica',
    ci_email: 'jorge.cervantessanabria@ucr.ac.cr',
    ci_image: ci_images['NoPhoto.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Cuba',
    ci_flag: flags['cub.png'],
    ci_name: 'Yaser Ramírez Benítez',
    ci_university: 'Municipal University Center, Rodas. Universidad de Cienfuegos, Cuba.',
    ci_email: 'yramirezbenitez@gmail.com',
    ci_image: ci_images['Yaser Ramírez Benítez.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Czech Republic',
    ci_flag: flags['cz.png'],
    ci_name: '--',
    ci_university: '--',
    ci_email: '--',
    ci_image: ci_images['NoPhoto.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Denmark',
    ci_flag: flags['dk.png'],
    ci_name: '--',
    ci_university: '--',
    ci_email: '--',
    ci_image: ci_images['NoPhoto.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Ecuador',
    ci_flag: flags['ec.png'],
    ci_name: 'José Francisco López Gil',
    ci_university: 'University of the Americas (Quito, Ecuador)',
    ci_email: 'josefranciscolopezgil@gmail.com',
    ci_image: ci_images['José Francisco López Gil Ecuador.jpg'],
    ci_bio: 'José Francisco López Gil, who holds a PhD in Physical Education from the University of Murcia (Spain) and a PhD in Sports Science from the Federal University of Paraná (Brazil), plays a key role as Director of Research at the Spanish Institute of Lifestyle Medicine. As a Senior Researcher at the University of the Americas (Quito, Ecuador), he combines his expertise with collaborative work at the Harvard T.H. Chan School of Public Health (Boston, USA). He also leads the Report Card initiative for the Region of Murcia (Spain) and actively participates as part of the Report Card team in Ecuador. His extensive professional achievements include more than 200 scientific articles published in indexed journals on lifestyle and health.'
  },
  {
    ci_country: 'Ethiopia',
    ci_flag: flags['et.png'],
    ci_name: 'Chalchisa Abdeta',
    ci_university: 'HI Ethiopia and University of Wollongong',
    ci_email: 'caaliphysio@gmail.com',
    ci_image: ci_images['Chalchisa Abdeta Tugu Ethiopia.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Fiji',
    ci_flag: flags['fg.png'],
    ci_name: 'Pragya Singh',
    ci_university: 'Fiji National University, Fiji',
    ci_email: 'pragya.singh@fnu.ac.fj',
    ci_image: ci_images['Pragya Singh Fiji.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Finland',
    ci_flag: flags['fn.png'],
    ci_name: 'Eva Roos',
    ci_university: 'Folkhälsan Research Center, Helsinki, Finland',
    ci_email: 'Eva.Roos@folkhalsan.fi',
    ci_image: ci_images['Eva Roos FINLAND.png'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Finland',
    ci_flag: flags['fn.png'],
    ci_name: 'Elina Engberg',
    ci_university: 'Folkhälsan Research Center, Helsinki, Finland',
    ci_email: 'elina.engberg@folkhalsan.fi ',
    ci_image: ci_images['Elina - Finland Co-CI.jpeg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Ghana',
    ci_flag: flags['gha.png'],
    ci_name: 'Vida Korleki Nyawornota',
    ci_university: 'University of Ghana',
    ci_email: 'vidakorleki@gmail.com',
    ci_image: ci_images['VIDA Ghana.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Greece',
    ci_flag: flags['gre.png'],
    ci_name: 'Fotini Venetsanou',
    ci_university: 'School of Physical Education and Sport Science, National and Kapodistrian, University of Athens',
    ci_email: 'fvenetsanou@phed.uoa.gr',
    ci_image: ci_images['Fotini Venetsanou Greece.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Hong Kong',
    ci_flag: flags['hk.png'],
    ci_name: 'Professor Amy HA SC',
    ci_university: 'The Chinese University of Hong Kong',
    ci_email: 'sauchingha@cuhk.edu.hk',
    ci_image: ci_images['Prof Amy Ha HONG KONG.png'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'India',
    ci_flag: flags['in.png'],
    ci_name: 'Himangi Lubree',
    ci_university: 'Vadu Rural Health Program & KEM Hospital Research Centre, Pune, India',
    ci_email: 'himangi.lubree@kemhrcvadu.org',
    ci_image: ci_images['Himangi Lubree India.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Indonesia',
    ci_flag: flags['id.png'],
    ci_name: 'Adang Suherman',
    ci_university: 'Universitas Pendidikan Indonesia',
    ci_email: 'adangsuherman@upi.edu',
    ci_image: ci_images['NoPhoto.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Iran',
    ci_flag: flags['ir.png'],
    ci_name: 'Najmeh Hamzavi Zarghani',
    ci_university: 'Tarbiat Modares University, Iran',
    ci_email: 'nadjmeh.hamzavi5@yahoo.com',
    ci_image: ci_images['Najmeh Hamzavi Zarghani _ Iran.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Italy',
    ci_flag: flags['it.png'],
    ci_name: 'Valentina Biino',
    ci_university: 'University of Verona',
    ci_email: '--',
    ci_image: ci_images['NoPhoto.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Japan',
    ci_flag: flags['jp.png'],
    ci_name: 'Chiaki Tanaka',
    ci_university: 'Tokyo Kasei Gakuin University, Japan',
    ci_email: 'c.tanaka@kasei-gakuin.ac.jp',
    ci_image: ci_images['Chiaki Tanaka Japan.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Kazakhstan',
    ci_flag: flags['kzk.png'],
    ci_name: 'Diana Shamgunova',
    ci_university: '--',
    ci_email: '--',
    ci_image: ci_images['NoPhoto.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Kenya',
    ci_flag: flags['ky.png'],
    ci_name: 'Amonje Moses Oluchiri',
    ci_university: 'Wellness for Greatness, Kenya',
    ci_email: 'm.oluchiri@wellnessforgreatness.org',
    ci_image: ci_images['MOSES Kenya.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Korea Republic',
    ci_flag: flags['ko.png'],
    ci_name: 'Dong Hoon Kim',
    ci_university: 'Korean Institute of Child Care and Education',
    ci_email: 'Dhkim@kicce.re.kr',
    ci_image: ci_images['NoPhoto.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Kyrgyzstan',
    ci_flag: flags['kyg.png'],
    ci_name: 'Saamay Abilova',
    ci_university: 'National Center of Cardiology and Internal Medicine',
    ci_email: 'abilova_s@mail.ru',
    ci_image: ci_images['Saamay Kyrgyzstan.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Lebanon',
    ci_flag: flags['lbn.png'],
    ci_name: 'Elie-Jacques Fares',
    ci_university: 'American University of Beirut',
    ci_email: 'e.j.fares@gmail.com',
    ci_image: ci_images['Elie-Jacques Fares_Photo_Lebanon.jpg']
  },
  {
    ci_country: 'Malawi',
    ci_flag: flags['mw.png'],
    ci_name: 'Tawonga Mwase-Vuma',
    ci_university: 'Centre for Social Research, University of Malawi',
    ci_email: 'taomwase@gmail.com',
    ci_image: ci_images['Tawonga Mwase-Vuma Malawi.png'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Malaysia',
    ci_flag: flags['ms.png'],
    ci_name: 'Denise CL Koh',
    ci_university: 'Universiti Kebangsaan Malaysia',
    ci_email: 'denise.koh@ukm.edu.my',
    ci_image: ci_images['Denise Koh Malaysia.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Mexico',
    ci_flag: flags['mx.png'],
    ci_name: 'Alejandra Jauregui de la Mota',
    ci_university: 'Colonia Santa María Ahuacatitlan',
    ci_email: 'Alejandra.jauregui@insp.mx',
    ci_image: ci_images['Alejandra Jauregui de la Mota_ Mexico.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Mongolia',
    ci_flag: flags['mn.png'],
    ci_name: 'Bayasgalan Jambaldorj',
    ci_university: 'National Centre for Public Health of Mongolia',
    ci_email: 'nom_bayasaa@yahoo.com',
    ci_image: ci_images['Bayasgalan Mongolia.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Morocco',
    ci_flag: flags['mo.png'],
    ci_name: 'Asmaa El Hamdouchi',
    ci_university: 'National Centre for Energy Sciences and Nuclear Techniques, Morocco',
    ci_email: 'asmaaelhamdouchi@gmail.com',
    ci_image: ci_images['asmaa morocco.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Namibia',
    ci_flag: flags['nmb.png'],
    ci_name: 'Matthew Chiwaridzo',
    ci_university: 'School of Allied Health Sciences, University of Namibia',
    ci_email: 'mchiwaridzo@unam.na',
    ci_image: ci_images['Matthew - Namibia.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Nepal',
    ci_flag: flags['npl.png'],
    ci_name: 'Narayan Subedi',
    ci_university: 'Nepal Development Society/Deakin University. Australia',
    ci_email: 'subedi.narayan@gmail.com',
    ci_image: ci_images['Narayan Subedi Nepal.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Nigeria',
    ci_flag: flags['ng.png'],
    ci_name: 'Aoko Oluwayomi',
    ci_university: 'University of Lagos, Nigeria',
    ci_email: 'yomiaoko@gmail.com',
    ci_image: ci_images['Aoko Oluwayomi Nigeria.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Norway',
    ci_flag: flags['no.png'],
    ci_name: 'Ingirid Geirsdatter Heald Kjær',
    ci_university: 'The University of Agde, Norway',
    ci_email: 'ingirid.g.kjar@uia.no',
    ci_image: ci_images['Ingirid-Norway.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Pakistan',
    ci_flag: flags['pk.png'],
    ci_name: 'Ali Turab',
    ci_university: 'PHC Global, Pakistan',
    ci_email: 'ali@phcglobal.org',
    ci_image: ci_images['Ali Turab Pakistan.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Papua New Guinea',
    ci_flag: flags['pg.png'],
    ci_name: 'Bang Nguyen Pham',
    ci_university: 'PNG Institute of Medical Research',
    ci_email: 'pnbang2001@yahoo.com',
    ci_image: ci_images['Bang Nguyen Pham PNG.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Poland',
    ci_flag: flags['pld.png'],
    ci_name: 'Hanna Nalecz',
    ci_university: 'Department of Pedagogy and Psychology, Jozef Pilsudski University of Physical Education',
    ci_email: 'hanna.nalecz@awf.edu.pl',
    ci_image: ci_images['Hanna Nalecz Poland.png'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Portugal',
    ci_flag: flags['pt.png'],
    ci_name: 'Clarice Maria Lucena Martins',
    ci_university: 'University of Porto, Portugal',
    ci_email: 'clarice@fade.up.pt',
    ci_image: ci_images['Clarice Martins.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Republic of Turkiye',
    ci_flag: flags['tur.png'],
    ci_name: 'Mehmet ',
    ci_university: '--',
    ci_email: '--',
    // ci_email: 'mehmetyildiz@aku.edu.tr',
    ci_image: ci_images['NoPhoto.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Russia',
    ci_flag: flags['ru.png'],
    ci_name: 'Anna Kontsevaya',
    ci_university: 'Department of Public Health, Russia',
    ci_email: 'koncanna@yandex.ru',
    ci_image: ci_images['Anna Kontsevaya_Russia.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Scotland',
    ci_flag: flags['scl.png'],
    ci_name: 'John Reilly',
    ci_university: 'University of Strathclyde, Scotland',
    ci_email: 'john.j.reilly@strath.ac.uk',
    ci_image: ci_images['John Reilly Scotland.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Singapore',
    ci_flag: flags['sg.png'],
    ci_name: 'Michael Chia',
    ci_university: 'National Institute of Education, Singapore',
    ci_email: 'Michael.chia@nie.edu.sg',
    ci_image: ci_images['Michael Chia Singapore (co-CI).jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Singapore',
    ci_flag: flags['sg.png'],
    ci_name: 'Wei-Peng Teo',
    ci_university: 'Department of Child and Adolescent Health, Institute of Mother and Child',
    ci_email: 'weipeng.teo@nie.edu.sg',
    ci_image: ci_images['NoPhoto.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'South Africa',
    ci_flag: flags['sa.png'],
    ci_name: 'Catherine Draper',
    ci_university: 'University of the Witwatersrand, South Africa',
    ci_email: 'pnbang2001@yahoo.com',
    ci_image: ci_images['Catherine Draper South Africa.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Spain',
    ci_flag: flags['sp.png'],
    ci_name: 'Jesús Del Pozo-Cruz',
    ci_university: 'University of Seville',
    ci_email: 'jpozo2@us.es',
    ci_image: ci_images['Jesus Spain.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Sri Lanka',
    ci_flag: flags['sr.png'],
    ci_name: 'Pujitha Wickramasinghe',
    ci_university: 'University of Colombo and Lady Ridgeway Hospital, Sri Lanka',
    ci_email: 'pujithaw@yahoo.com',
    ci_image: ci_images['Pujitha Wickramasinghe Sri Lanka.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Sweden',
    ci_flag: flags['sw.png'],
    ci_name: 'Marie Löf',
    ci_university: 'Linköping University and Karolinska Institutet, Sweden',
    ci_email: 'marie.lof@ki.se',
    ci_image: ci_images['Marie Löf Sweden.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Tanzania',
    ci_flag: flags['tz.png'],
    ci_name: 'Germana H Leyna',
    ci_university: '--',
    ci_email: '--',
    // ci_email: 'gerryleyna@yahoo.com',
    ci_image: ci_images['NoPhoto.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Thailand',
    ci_flag: flags['th.png'],
    ci_name: 'Piyawat Katewongsa',
    ci_university: 'Institute for Population and Social Research, Mahidol University',
    ci_email: 'piyawat.kat@mahidol.edu',
    ci_image: ci_images['Piyawat Katewongsa_Thailand.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Thailand',
    ci_flag: flags['th.png'],
    ci_name: 'Dyah Anantalia Widyastari',
    ci_university: 'Institute for Population and Social Research, Mahidol University',
    ci_email: 'dyah.ana@mahidol.edu',
    ci_image: ci_images['Dyah Anantalia Widyastari-Thailand.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'The Netherlands',
    ci_flag: flags['nt.png'],
    ci_name: 'Sanne Veldman',
    ci_university: 'Mulier Institute, The Netherlands',
    ci_email: 's.veldman@mulierinstituut.nl',
    ci_image: ci_images['Sanne Veldman Netherlands.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'The Philippines',
    ci_flag: flags['ph.png'],
    ci_name: 'Marites Tiongco',
    ci_university: 'De La Salle University, The Philippines',
    ci_email: 'marites.tiongco@dlsu.edu.ph',
    ci_image: ci_images['Marites Tiongco Philippines.png'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Timor-Leste',
    ci_flag: flags['tl.png'],
    ci_name: '--',
    ci_university: '--',
    ci_email: '--',
    ci_image: ci_images['NoPhoto.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Tunisia',
    ci_flag: flags['tnu.png'],
    ci_name: 'Mohamed Souhaiel Chelly',
    ci_university: 'Higher Institute of Sport and Physical Education of Ksar Saîd, University of Manouba, Tunis, Tunisia.',
    ci_email: 'mohamedsouhaiel.chelly@issep.uma.tn',
    ci_image: ci_images['Chelly MS Tunisia.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Turkiye',
    ci_flag: flags['tur.png'],
    ci_name: 'Lillian Mugie',
    ci_university: '--',
    ci_email: '--',
    ci_image: ci_images['NoPhoto.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'United Arab Emirates',
    ci_flag: flags['uae.png'],
    ci_name: 'Alison Thirlwall',
    ci_university: '--',
    ci_email: '--',
    // ci_university: 'University of Wollongong Dubai',
    // ci_email: 'AlisonThirlwall@uowdubai.ac.ae',
    ci_image: ci_images['NoPhoto.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'United States of America',
    ci_flag: flags['usa.png'],
    ci_name: 'Kip Webster',
    ci_university: 'The University of Tennessee, USA',
    ci_email: 'kipwebster@utk.edu',
    ci_image: ci_images['Kip Webster USA Augusta.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'United States of America',
    ci_flag: flags['usa.png'],
    ci_name: 'Amanda Staiano',
    ci_university: 'LSU\'s Pennington Biomedical Research Centre, USA',
    ci_email: 'Amanda.staiano@pbrc.edu',
    ci_image: ci_images['Amanda Staiano USA Pennington.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Uruguay',
    ci_flag: flags['uru.png'],
    ci_name: 'Javier Brazo - Sayavera',
    ci_university: 'Universidad Pablo de Olavide (Spain)',
    ci_email: 'jbsayavera@upo.es',
    ci_image: ci_images['JavierBrazoSayavera Uruguay.png'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Vietnam',
    ci_flag: flags['vt.png'],
    ci_name: 'Tang Kim Hong',
    ci_university: 'Pham Ngoc Thach University of Medicine, Vietnam',
    ci_email: 'hong.tang@pnt.edu.vn',
    ci_image: ci_images['Hong K Tang Vietnam.jpg'],
    ci_bio: 'Not Available'
  },
  {
    ci_country: 'Zimbabwe',
    ci_flag: flags['zw.png'],
    ci_name: 'Nyaradzai Dangarembizi Munambah',
    ci_university: 'University of Zimbabwe',
    ci_email: 'nyaradzaidangarembizi@yahoo.co.uk',
    ci_image: ci_images['Nyarie Dangarembizi Zimbabwe.jpg'],
    ci_bio: 'Not Available'
  },
];

const ChiefInvestigator = () => {
  const [isFlipped, setIsFlipped] = useState(false);

  const handleMouseEnter = (index) => {
    setIsFlipped((prevState) => {
      const updatedState = [...prevState];
      updatedState[index] = true;
      return updatedState;
    });
  };

  const handleMouseLeave = (index) => {
    setIsFlipped((prevState) => {
      const updatedState = [...prevState];
      updatedState[index] = false;
      return updatedState;
    });
  };

  useEffect(() => {
    document.title = "Chief Investigators"
    setIsFlipped(ci_data.map(() => false));
  }, []);
  return (
    <div className="ci">
      <Header2 />
      <h1 style={{ color: '#494b4d', textAlign: 'center', width: '100%' }}>Chief Investigators</h1>
      <p>&nbsp;</p>
      <div className='ci_cards load'>

        {ci_data.map((item, index) => (
          // return (
          <MDBCol key={index}
            className={`card ${isFlipped[index] ? 'flipped' : ''}`}
            onMouseEnter={() => handleMouseEnter(index)}
            onMouseLeave={() => handleMouseLeave(index)}>
            {/* <MDBCol key={index}
              className={`card ${isFlipped[index] ? 'flipped' : ''}`}> */}
            <div className='card-inner'>
              <MDBCard className="card-front">
                <MDBCardText style={{ fontSize: '17px', fontWeight: 'bold', color: '#f05f54', marginTop: '20px' }}>
                  <em>{item.ci_country}</em>
                </MDBCardText><br />
                <MDBCardImage style={{ border: '1px solid black', borderRadius: '0%', height: '70px', width: '130px', marginBottom: '10px' }}
                  src={item.ci_flag}
                  alt='{}'
                  position='top'
                /><br /><br />
                <MDBCardImage style={{ objectFit: 'cover', pointerEvents:'none', userSelect:'none' }}
                  src={item.ci_image}
                  alt='{}'
                  position='top'
                />
                <MDBCardBody>
                  <MDBCardTitle style={{ padding: '10px 10px 10px 20px', fontSize: '17px' }}>{item.ci_name}</MDBCardTitle>
                  <div style={{ display: 'flex' }}>
                    <SchoolIcon style={{ color: '#2a4a80', margin: '10px 0px 0px 10px' }} />
                    <MDBCardText style={{ textAlign: 'start', margin: '10px 20px 0px 10px', fontSize: '14px', color: '#f05f54' }}>
                      {item.ci_university}
                    </MDBCardText>
                  </div>
                </MDBCardBody>
                <MDBCardFooter>
                  <div style={{ display: 'flex' }}>
                    <EmailIcon style={{ color: '#2a4a80', margin: '10px 0px 10px 10px' }} />
                    <MDBCardText style={{ margin: '0px 20px 0px 10px', textAlign: 'start', fontSize: '14px', color: '#f05f54' }}><br />
                      {item.ci_email}
                    </MDBCardText>
                  </div>
                </MDBCardFooter>
              </MDBCard>
              <MDBCard className="card-back">
                <MDBCardImage style={{ objectFit: 'cover', marginTop: '20px' }}
                  src={item.ci_image}
                  alt='{}'
                  position='top'
                />
                <MDBCardBody>
                  <MDBCardTitle style={{ padding: '10px 10px 0px 20px', fontSize: '17px', color: 'black' }}>{item.ci_name}</MDBCardTitle>
                </MDBCardBody>
                <MDBCardFooter>
                  <div style={{ display: 'flex' }}>
                    <MDBCardText style={{ margin: '0px 20px 0px 20px', textAlign: 'start', fontSize: '14px', color: '#f05f54', textAlign: 'justify', userSelect: 'none' }}><br />
                      {item.ci_bio}
                    </MDBCardText>
                  </div>
                </MDBCardFooter>
              </MDBCard>
            </div>
            {/* </div> */}
          </MDBCol>
        ))}
      </div>
      <Footer />

    </div>
  );
}

export default ChiefInvestigator;